<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="trash-bin"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <g id="Group_727" data-name="Group 727" transform="translate(3.75 2.646)">
      <path
        id="Path_8090"
        data-name="Path 8090"
        d="M14.75,5.78h.75M8,8.734V13.28m2.25-5.415v6.2M12.5,8.734V13.28m.6,2.956H7.4A1.654,1.654,0,0,1,5.75,14.582v-8.8h9v8.8A1.654,1.654,0,0,1,13.1,16.236ZM13.25,5.778,12.7,4.049a.751.751,0,0,0-.714-.521H8.518a.749.749,0,0,0-.714.521L7.25,5.778M5,5.78h.75"
        transform="translate(-5 -3.528)"
        fill="none"
        :stroke="clr ? clr : '#323232'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
    </g>
    <path id="Path_8091" data-name="Path 8091" d="M0,0H18V18H0Z" fill="none" />
  </svg>
</template>
